export default function Resources(){
  return (
    <section className="container py-16">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">Resources</h1>
      <ul className="grid md:grid-cols-2 gap-6 mt-8">
        {['Visa Guide PDF','Packing Checklist','Budget Planner Sheet','Top 100 Destinations'].map(r => (
          <li key={r} className="card p-6 flex items-center justify-between">
            <span className="font-medium">{r}</span>
            <button className="btn-outline">Download</button>
          </li>
        ))}
      </ul>
    </section>
  );
}
